// extracted by mini-css-extract-plugin
export default {"zooplus":"themes-module__zooplus--qmcQp","bitiba":"themes-module__bitiba--AblB5"};